module.exports = __webpack_public_path__ + "static/media/NouvelR-Light.d3f217c2.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/nouvel/NouvelR-Light.woff2
// module id = 744
// module chunks = 6